<template>
  <div class="header" style="min-width:1440px;">
    <div v-if="title=='English'" class="spaceAround"  style="width:100%">
      <div style="margin-right:20px">
          <img class="logo" src="http://www.ispunion.org/logo_mini.png" alt="">
      </div>
      <ul class="header_main_English" >
        <li v-for="nav in navs" :key='nav.id'><router-link exact  :to='nav.path' >{{nav.title}}</router-link></li>
      </ul>
      <div style="margin-left:20px">
        <div class="en" @click="changeLang">{{title}}</div>
      </div>
    </div>
    <div v-else class="spaceAround"  style="width:100%;white-space: nowrap">
      <div style="margin-right:20px">
          <img class="logo" src="http://www.ispunion.org/logo_mini.png" alt="">
      </div>
      <ul class="header_main" >
        <li v-for="nav in navs" :key='nav.id'><router-link exact  :to='nav.path' >{{nav.title}}</router-link></li>
      </ul>
      <div style="margin-left:20px">
        <div class="en" @click="changeLang">{{title}}</div>
      </div>
    </div>
    <div style="flex:1" ref="content" :style="{width:widths}"></div>
  </div>
</template>

<script>
export default {
  name: 'appHeader',
  data() {
    return {
      title:"英文",
      widths:''
    }
  },
  props: {
    
  },
   computed:{
    navs(){
      return [
        { id:1, path:'/home', title:this.$t('navs.nav1')},
        { id:2, path:'/union', title:this.$t('navs.nav2')},
        { id:3, path:'/company', title:this.$t('navs.nav3')},
        { id:4, path:'/aboutAlliances', title:this.$t('navs.nav4')},
        // { id:4, path:'/aboutAlliances/aboutAlliances1', title:this.$t('navs.nav4')},
        { id:5, path:'/forumArticles', title:this.$t('navs.nav5')},
        { id:6, path:'/works', title:this.$t('navs.nav6')},
        { id:7, path:'/member', title:this.$t('navs.nav7')},
        { id:8, path:'/sponsor', title:this.$t('navs.nav8')},
        { id:9, path:'/contact', title:this.$t('navs.nav9')},
      ]
    }
      
  },
  created(){
    if(sessionStorage.getItem('chOrEn')==0){
        this.title="简体中文"
    }
    if(sessionStorage.getItem('chOrEn')==1){
        this.title="English"
    }
    // this.newAddBtn()
  },
  methods:{
    changeLang(){
      if(this.title=="English"){
            this.title="简体中文"
        }else{
            this.title="English"
        }
      let locale = this.$i18n.locale
      let chOrEn = '1'
      locale === 'zh' ? this.$i18n.locale = 'en' : this.$i18n.locale = 'zh';
      locale === 'zh' ? chOrEn = '0' : chOrEn = '1';
      sessionStorage.setItem('lang',this.$i18n.locale)
      sessionStorage.setItem('chOrEn',chOrEn)
      if(this.$route.name=="forumArticles2"){
        this.$router.push({
          path: '/forumArticles',
        })
      }else if(this.$route.name=="aboutAlliances1"){
		this.$router.push({
		path: '/aboutAlliances',
		})
      }else{
        this.$router.go(0)
        window.location.reload()
      }
    },
  },
  mounted(){
    setTimeout(()=>{
      // debugger
        this.widths=(this.$refs.content.clientWidth/2)+"px"
    },20)
  }
}
</script>
<style lang="less" scoped >
.header{
  width:100%;
  padding-left:1%;
  padding-right:1%;
}
.spaceAround{
  display: flex;
  justify-content:space-around;
  align-items:center;
}
.en{
    padding:3px 12px;
    // width: 64px;
    // height: 24px;
    // background: #0a2f8e;
    // color: #fff;
    font-size:12px;
    // font-weight: bold;
    background: rgba(216, 216, 216, 0);
    
    border: 2px solid #787878;
    text-align: center;
    line-height: 20px;
    border-radius: 20px;
    color: #2A303C;
    cursor: pointer;
    
  }
.header{
  width: 100%;
  // position: fixed;
  left: 0;
  top:0;
  z-index: 66;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  background: #FFFFFF;
  .spaceAround{
    display: flex;
    justify-content:space-around;
    align-items:center;
    .border{
      position: absolute;
      width: 100%;
      height: 1px;
      background: #ccc;
      z-index: 67;
      left:0;
      bottom:0;
    }
  }
}
.header_left_bg_English{
    // width: 30%;
    height: 118px;
    background: url('../assets/img/header_bg.png') no-repeat;
    // position: absolute;
    // left:0;
    // top:0;
    background-size: 100% 100%;
    // z-index: 68;
    display: flex;
    align-items: center;
    justify-content: flex-end;
    padding-right: 4%;
    .logo_box{
      width: 245px;
      height: 80px;
      a{
        display: block;
        width: 100%;
        height: 100%;
        color: #1C1C1C;
        img{
          width: 100%;
          height: 100%;
        }
      }
    }
  }
.header_left_bg{
    width: 19%;
    height: 118px;
    background: url('../assets/img/header_bg.png') no-repeat;
    position: absolute;
    left:0;
    top:0;
    background-size: 100% 100%;
    z-index: 68;
    display: flex;
    align-items: center;
    justify-content: flex-end;
    padding-right: 4%;
    .logo_box{
      width: 245px;
      height: 80px;
      a{
        display: block;
        width: 100%;
        height: 100%;
        color: #1C1C1C;
        img{
          width: 100%;
          height: 100%;
        }
      }
    }
  }
.header{
  width: 100%;
  height: 110px;
  // background: none;
  box-shadow:0px 12px 8px -12px #ccc;
  .spaceAround{
    display: flex;
    justify-content:space-around;
    align-items:center;
    .header_main_English{
      padding-left:30px;
      padding-right:30px;
      width:100%;
      height: 110px;
      background: #fff;
      // padding-left: 30%;
      display: flex;
      align-items: center;
      justify-content:space-around;
      font-size:16px;
      // font-weight: bold;
      li{
        // padding:0 28px;
        height: 100%;
        line-height: 110px;
        box-sizing: border-box;
        display: flex;
        justify-content:space-around;
        align-items: center;
        a{
          display: flex;
          align-items: center;
          line-height: 30px;
          width: 100%;
          height: 100%;
           color: #1C1C1C;
        }
        // .en{
        //   width: 60px;
        //   height: 26px;
        //   background: #0a2f8e;
        //   color: #fff;
        //   font-size:18px;
        //   // font-weight: bold;
        //   background: rgba(216, 216, 216, 0);
          
        //   border: 1px solid #2A303C;
          
        //   text-align: center;
        //   line-height: 26px;
        //   border-radius: 5px;
        //   cursor: pointer;
        // }
      }
      li:hover{
        a{
          color:  #0a2f8e;
          font-weight: 800;
        }
      }
      
    }
    .header_main{
      height: 110px;
      background: #fff;
      // padding-left: 19%;
      display: flex;
      align-items: center;
      justify-content:center;
      font-size:16px;
      // font-weight: bold;
      li{
        padding:0 10px;
        height: 100%;
        line-height: 110px;
        box-sizing: border-box;
        display: flex;
        align-items: center;
        a{
          display: flex;
          align-items: center;
          line-height: 30px;
          width: 100%;
          height: 100%;
           color: #1C1C1C;
        }
        .en{
          width: 60px;
          height: 26px;
          background: #0a2f8e;
          color: #fff;
          font-size:18px;
          // font-weight: bold;
          background: rgba(216, 216, 216, 0);
          
          border: 1px solid #2A303C;
          text-align: center;
          line-height: 26px;
          border-radius: 5px;
          cursor: pointer;
        }
      }
      li:hover{
        a{
          color:  #0a2f8e;
          font-weight: 800;
        }
      }
      
    }
  }
}

.router-link-active{
	font-weight: 800;
  color: #0a2f8e!important;
  border-bottom: 5px solid #0a2f8e;
  box-sizing: border-box;
}

</style>
